// extracted by mini-css-extract-plugin
export var breadcrumb = "_16-0";
export var breadcrumbArrow = "_16-1";